import {is_on_premises, parseKBSubdomain} from "../App/utils";

const offlineQueue = [];
let isProcessing = false;

export let wssInstance;
const baseReconnectInterval = 5000; // Base time in milliseconds to wait before trying to reconnect
let currentReconnectInterval = baseReconnectInterval;
let reconnectAttempts = 0;

let seenEvents = {};
export function initWS(reconnect) {
    const isKbSubdomain = !!parseKBSubdomain();

    // First, try to get the regular token
    let token = isKbSubdomain
        ? localStorage.getItem('kbJWT')
        : localStorage.getItem("clientJWT");

    let usesPublicChatToken = false;

    // If we're on a KB subdomain and no kbJWT token exists
    if (isKbSubdomain && !token) {
        const publicChatToken = localStorage.getItem('publicChatToken');
        if (publicChatToken) {
            token = publicChatToken;
            usesPublicChatToken = true;
        }
    }

    if (!token) return;

    // Construct the wsURL accordingly
    let wsURL;
    if (isKbSubdomain) {
        const tokenParam = usesPublicChatToken ? 'publicChatToken' : 'token';
        wsURL = `wss://ws.openkbs.com?${tokenParam}=` + encodeURIComponent(token);
    } else {
        wsURL = 'wss://websocket.openkbs.com?token=' + encodeURIComponent(token);
    }

    // Handle on-premises cases as before
    if (is_on_premises && !reconnect) {
        let currentOrigin = window.location.origin;

        // Remove the {kbId}.apps subdomain prefix from the ChatAPI WS url
        currentOrigin = currentOrigin.replace(/^http:\/\/[^.]+\.apps\./, 'ws://').replace(/^https:\/\/[^.]+\.apps\./, 'wss://');

        // Construct the new API URL with the specified port
        wsURL = `${currentOrigin.split(':')[0]}:${currentOrigin.split(':')[1]}:38594?${usesPublicChatToken ? 'publicChatToken' : 'token'}=` + encodeURIComponent(token);
    }

    wssInstance = new WebSocket(wsURL);

    wssInstance.onopen = () => {
        currentReconnectInterval = baseReconnectInterval; // Reset the interval on successful connection
        reconnectAttempts = 0; // Reset the attempts counter
        processQueue(wssInstance); // Process any messages that were queued while offline
    };

    wssInstance.onclose = () => {
        reconnectAttempts++;
        currentReconnectInterval = reconnectAttempts < 2
            ? 100
            : Math.round(Math.min(baseReconnectInterval * Math.pow(2, reconnectAttempts / 2), 300000)); // Cap at 5 minutes
        setTimeout(() => initWS(reconnectAttempts), currentReconnectInterval); // Attempt to reconnect
    };

    wssInstance.onerror = (error) => {
        console.error('WebSocket encountered an error:', error);
        wssInstance.close(); // Ensure the socket is closed before trying to reconnect
    };

    wssInstance.onmessage = (event) => {
        const messageEvent = new CustomEvent('onWebsocketMessage', { detail: event.data });
        const eventID = event?.data?.eventID;

        // prevent double execution
        if (eventID && seenEvents[eventID]) return;
        seenEvents[eventID] = 1
        // prevent memory leak
        if (Object.keys(seenEvents)?.length > 10000) seenEvents = {};

        window.dispatchEvent(messageEvent);
    };
}

export function wsSend(payload) {
    if (wssInstance && wssInstance?.readyState === WebSocket.OPEN) {
        wssInstance.send(JSON.stringify(payload));
    } else {
        offlineQueue.push(payload);
        if (!isProcessing) {
            processQueue(wssInstance);
        }
    }
}

function processQueue(wss) {
    isProcessing = true;
    if (wss && wss?.readyState === WebSocket.OPEN) {
        while (offlineQueue.length) {
            const payload = offlineQueue.shift();
            wss.send(JSON.stringify(payload));
        }
    }

    if (wss?.readyState !== WebSocket.OPEN && offlineQueue.length > 0) {
        setTimeout(() => processQueue(wss), 1000);
    } else {
        isProcessing = false;
    }
}